import { render, staticRenderFns } from "./PhpCodeEditor.vue?vue&type=template&id=72c756aa&scoped=true&"
import script from "./PhpCodeEditor.vue?vue&type=script&lang=js&"
export * from "./PhpCodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./PhpCodeEditor.vue?vue&type=style&index=0&id=72c756aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c756aa",
  null
  
)

export default component.exports